const LogoShort = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			d="M6.99435 17.2126C6.99435 15.8822 7.5351 14.556 8.60672 13.5779C10.6543 11.7066 13.8626 11.8176 15.7706 13.8246C16.6817 14.7823 17.1301 15.9985 17.1301 17.2126H23.2356L18.3457 15.5881L21.8123 11.7174L16.6861 12.7193L17.7083 7.69486L13.7801 11.0754L12.1018 6.22223L10.4235 11.0743L6.49537 7.69486L7.50873 12.6751L2.61119 11.7174L6.00957 15.5116L0.888916 17.2126H6.99435Z"
			fill="#F0D900"
		/>
	</svg>
);

export default LogoShort;
